import { apiFetch } from './api-client';

export const getTenant = () => {
    const { response, cancel } = apiFetch('GET', '/tenant/', { authenticate: false });
    return { data: response.then((res) => res.json()), cancel };
};
